




import { Vue, Component, Watch } from 'vue-property-decorator';
import { stringify } from 'qs';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class MessageIframe extends Vue {
  private remoteSrc = '';

  created() {
    this.setRemoteSrc();
  }

  @Watch('$route.path', { immediate: false, deep: false })
  private setRemoteSrc() {
    const { path, query } = this.$route;

    if (this.remoteSrc) {
      const { pathname } = new URL(this.remoteSrc);
      const regex = /\/member\/message\/([^/]+)/;
      const prevMatch = pathname.match(regex);
      const nextMatch = path.match(regex);

      if (prevMatch?.[1] === nextMatch?.[1]) {
        return;
      }
    }

    this.remoteSrc = `${process.env.VUE_APP_ADMIN_REMOTE_URL}${path}${stringify({ ...query, serviceType: 'PRO' }, { addQueryPrefix: true })}`;
  }
}
